import React, { useContext, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { RadioButtonComponent } from "@syncfusion/ej2-react-buttons";
import { CredsContext } from "./Contexts";
import Tools from "./JNSTools";
import "./styles/Settings.css";

function SettingsProjectsETCCalc() {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));

  let settings;
  const settingsRaw = localStorage.getItem("oadaSettings");
  if (settingsRaw) {
    settings = JSON.parse(settingsRaw);
  }

  const [optionSelected, setOptionSelected] = useState("budgetTimesRemaining");

  const handleRadioChange = (event) => {
    const optionId = event.event.target.id;
    settings.etcCalcOption = optionId;
    localStorage.setItem("oadaSettings", JSON.stringify(settings));
    Tools.writeSettings(creds, projectObject.id);
    setOptionSelected[optionId];
  };

  useEffect(() => {
    if (settings.etcCalcOption) {
      setOptionSelected(settings.etcCalcOption);
    }
  }, []);
  return (
    <Box>
      <Typography sx={{ color: "white", paddingLeft: "15px" }}>
        ETC Calculation Method:
      </Typography>
      <RadioButtonComponent
        id="budgetTimesRemaining"
        change={handleRadioChange}
        cssClass="settingsRadioButtonStyle"
        label="Budget times Percent Remaining (100 minus Percent Complete)"
        name="default"
        checked={optionSelected == "budgetTimesRemaining"}
      />
      <br></br>
      <RadioButtonComponent
        id="evm"
        change={handleRadioChange}
        cssClass="settingsRadioButtonStyle"
        label="Earned Value Management (EVM) Standard [Budget At Completion minus Earned Value, then divided by Cost Performance Index]"
        name="default"
        checked={optionSelected == "evm"}
      />
      <br></br>
      <RadioButtonComponent
        id="futureBooked"
        change={handleRadioChange}
        cssClass="settingsRadioButtonStyle"
        label="Future Booked Hours/Charge Projections"
        name="default"
        checked={optionSelected == "futureBooked"}
      />
      <br></br>
      <RadioButtonComponent
        id="plannedMinusActual"
        change={handleRadioChange}
        cssClass="settingsRadioButtonStyle"
        label="Planned Hours minus Actual Hours (Projected Charges minus Actual Charges)"
        name="default"
        checked={optionSelected == "plannedMinusActual"}
      />
      <br></br>
      <RadioButtonComponent
        id="bookedMinusActual"
        change={handleRadioChange}
        cssClass="settingsRadioButtonStyle"
        label="Total Booked Hours minus Actual Hours (Projected Charges minus Actual Charges)"
        name="default"
        checked={optionSelected == "bookedMinusActual"}
      />
      <br></br>
      <RadioButtonComponent
        id="useManual"
        change={handleRadioChange}
        cssClass="settingsRadioButtonStyle"
        label="Use manually set value from ETC field on SuiteProjects Pro project"
        name="default"
        checked={optionSelected == "useManual"}
      />
    </Box>
  );
}

export default SettingsProjectsETCCalc;

SettingsProjectsETCCalc.propTypes = {};
